import axios from 'axios'
import * as moment from 'moment'
import { currentSessionShared } from '../utils/authSession'
import { setItemToLocalStorage } from '../utils/setLocalStorage'
import { baseURL } from './constants'

const ANONYMOUS_ALLOWED_AUTH_PATHS = [
  '/api/v1/auth/verify-recaptcha',
  '/api/v1/auth/signup',
  '/api/v1/auth/signin',
  '/api/v1/auth/social-signup',
  '/api/v1/auth/send-verification-otp',
  '/api/v1/auth/verify-email-otp',
  '/api/v1/auth/verify-cognito-email',
  '/api/v1/auth/validate-email-domain',
]

const isAnonymousAllowedAuthPath = (url?: string): boolean => {
  if (!url) return false
  return ANONYMOUS_ALLOWED_AUTH_PATHS.some(path => url.includes(path))
}

const attachReferralHeaders = (config: any) => {
  const referralIdFallBackJSON =
    window.localStorage.getItem('referralId') || '{}'
  const referralIdFallBack = JSON.parse(referralIdFallBackJSON)
  if (Object.keys(referralIdFallBack)?.length) {
    const { id, time } = referralIdFallBack
    const referralIdAge = moment().diff(moment(time), 'days')
    if (referralIdAge <= 3) {
      config.headers['Referral-Id'] = id
    }
  }

  const referralJoinBrand = JSON.parse(
    window.sessionStorage.getItem('brandJoinFlow') || '{}'
  )
  if (referralJoinBrand.brandId && referralJoinBrand.referrerId) {
    config.headers['Ref-Brand-Id'] = String(referralJoinBrand.brandId)
    config.headers['Ref-User-Id'] = String(referralJoinBrand.referrerId)
  }

  return config
}

const instance = axios.create({
  baseURL: baseURL,
})

instance.defaults.headers.common['Authorization'] = 'AUTH TOKEN'
instance.defaults.headers.post['Content-Type'] = 'application/json'
instance.defaults.headers.common['Referral-Id'] = ''
instance.defaults.headers.common['X-Source'] = 'WEBSITE'

instance.interceptors.request.use(function(config) {
  if (isAnonymousAllowedAuthPath(config.url)) {
    config.headers.Authorization = 'AUTH TOKEN'
    return Promise.resolve(attachReferralHeaders(config))
  }

  return currentSessionShared()
    .then(session => {
      config.headers.Authorization = `Bearer ${session
        .getIdToken()
        .getJwtToken()}`

      return Promise.resolve(attachReferralHeaders(config))
    })
    .catch(() => {
      config.headers.Authorization = 'AUTH TOKEN'
      return Promise.resolve(attachReferralHeaders(config))
    })
})

instance.interceptors.response.use(
  (response: any) => {
    let url = response.config.url.split('/')
    url.length == 8 ? url.splice(6, 1) : url.splice(3, 1)
    url = url.join('/')
    if (
      url === 'api/v1/users/profile' ||
      url.includes('api/v1/users/profile')
    ) {
      setItemToLocalStorage(
        'profile',
        JSON.stringify({
          firstName: response?.data?.data?.name.split(' ')[0],
          lastName: response?.data?.data?.name.split(' ')[1],
          username: response?.data?.data?.username,
          email: response?.data?.data?.email,
        })
      )
    }

    return response
  },
  error => {
    return Promise.reject(error)
  }
)

export default instance
